import { render } from "./DaycareOrders.vue?vue&type=template&id=4a4bf4bc&scoped=true"
import script from "./DaycareOrders.vue?vue&type=script&lang=js"
export * from "./DaycareOrders.vue?vue&type=script&lang=js"

import "./DaycareOrders.vue?vue&type=style&index=0&id=4a4bf4bc&scoped=true&lang=css"

import exportComponent from "/var/www/html/projects/hetfruit/resources/vueapps/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4bf4bc"]])

export default __exports__